export const CHARITY_DGR_TAX_OPTIONS = [
  { value: 'dgr1', label: 'Australian Charity - DGR Item 1' },
  { value: 'dgr2', label: 'Australian Charity - DGR Item 2' },
] as const;

export type CharityDgrTaxStatus = (typeof CHARITY_DGR_TAX_OPTIONS)[number]['value'] | '';

export function formatCharityDgrTaxStatus(value: string | null | undefined): string {
  if (!value) {
    return '—';
  }
  const option = CHARITY_DGR_TAX_OPTIONS.find((item) => item.value === value);
  return option?.label ?? value;
}
